import { useStyles } from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import cn from "classnames";

interface IToggleIconProps {
    onClick: () => void;
    open: boolean;
    sideRef: React.RefObject<HTMLDivElement>;
}

export const ToggleIcon = ({ onClick, open, sideRef }: IToggleIconProps) => {
    const sideContainerHeight = sideRef?.current?.clientHeight;
    const sideContainerWidth = sideRef?.current?.clientWidth;
    const styles = useStyles({ sideContainerHeight, sideContainerWidth });

    return (
        <div
            className={cn(styles.wrapperToggleIcon, { open })}
            onClick={onClick}
        >
            <CloseIcon
                color="inherit"
                className={cn(styles.icon, { hidden: !open })}
            />
            <ArrowForwardIosIcon
                color="inherit"
                className={cn(styles.icon, { hidden: open })}
            />
        </div>
    );
};
